__turbopack_context__.v({
  "divider": "Login-module__0PyEKq__divider",
  "errorMsg": "Login-module__0PyEKq__errorMsg",
  "googleBtn": "Login-module__0PyEKq__googleBtn",
  "googleButtonWrapper": "Login-module__0PyEKq__googleButtonWrapper",
  "heading": "Login-module__0PyEKq__heading",
  "input": "Login-module__0PyEKq__input",
  "label": "Login-module__0PyEKq__label",
  "links": "Login-module__0PyEKq__links",
  "loginBox": "Login-module__0PyEKq__loginBox",
  "pageWrapper": "Login-module__0PyEKq__pageWrapper",
  "submitBtn": "Login-module__0PyEKq__submitBtn",
});
